import dayjs from 'dayjs'
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { googleDocsTypes, imageTypes, pdfType, videoTypes } from '~/Constants'
import Dialog from '~/components/Dialog'
import { formatFileSize } from '~/utils/helpers'
import { InformationWrapper, PrevievWrapper } from '../../style'
import { Button } from 'semantic-ui-react'
import { FileData, FileSrcType } from '..'

type FilesType = {
  rows: FileData[]
}

interface PreviewFileModalProps {
  fileSource: FileSrcType
  dataFiltered: any
  handleClose: () => void
  files: FilesType
  setFiles: (files: FilesType) => void
  isBusy: boolean
}

const PreviewFileModal: React.FC<PreviewFileModalProps> = (props) => {
  const {
    fileSource,
    dataFiltered,
    handleClose,
    files,
    setFiles,
    isBusy
  } = props
  const { t } = useTranslation()
  const refIframe = useRef(null)

  useEffect(() => {
    if (googleDocsTypes.find(type => type === fileSource?.type)) {
      handleRefreshClick()
    }
  }, [fileSource])

  function renderPreviewInformation() {
    return <>
      <div style={{ textAlign: 'initial' }}>
        <div className='label'>{t('Created at:')}</div>
        <div className='value'>{dayjs(fileSource?.createdAt).format('DD.MM.YYYY HH:mm')}</div>
      </div>
      <div style={{ textAlign: 'initial' }}>
        <div className='label'>{t('File type:')}</div>
        <div className='value'>{fileSource?.type}</div>
      </div>
      <div style={{ textAlign: 'initial' }}>
        <div className='label'>{t('File size:')}</div>
        <div className='value'>{formatFileSize(fileSource?.size)}</div>
      </div>
    </>
  }

  function handleRefreshClick() {
    if (refIframe.current) {
      refIframe.current.setAttribute('src', '')
      const encodedUrl = encodeURIComponent(fileSource?.src);
      // Construct the embedded URL
      const embeddedUrl = `https://docs.google.com/gview?url=${encodedUrl}&embedded=true`;
      refIframe.current.setAttribute('src', embeddedUrl)
    }
  }

  const googleDocsType = googleDocsTypes.find(type => type === fileSource?.type)

  return <Dialog
    open={Boolean(fileSource?.src)}
    heightDialog={pdfType === fileSource?.type ? null : 'auto'}
    handleClose={() => {
      if (dataFiltered.folderId === 'newFolder') {
        const element = document.getElementById('newFolder')
        if (element) {
          element.innerText = `(${files?.rows?.length - 1})`
          setFiles({ ...files, rows: files?.rows?.filter(file => file.id !== fileSource.id) })
        }
      }
      refIframe.current = null
      handleClose()
    }}
    textContent={<div style={{ position: 'relative', width: '100%', minHeight: '500px', height: '100%' }}>
      {typeof (fileSource?.src) === 'string' && <>
        <InformationWrapper>
          {renderPreviewInformation()}
          <Button type={'button'}
            onClick={() => handleRefreshClick()}
            basic
            icon={'refresh'}
            content={t('Refresh')} />
        </InformationWrapper>
        <PrevievWrapper>
          {(imageTypes.find(imageType => imageType === fileSource?.type)) && <img src={fileSource?.src as string} alt='Preview' />}
        </PrevievWrapper>
        <PrevievWrapper>
          {videoTypes.find(videoType => videoType === fileSource?.type) && <video src={fileSource?.src as string} controls />}
        </PrevievWrapper>
        {googleDocsType && fileSource?.src && (
          <iframe
            ref={refIframe}
            src={`https://docs.google.com/viewer?url=${encodeURIComponent(fileSource?.src)}&embedded=true`}
            width='100%'
            height='90%'
            style={{ minHeight: 500 }}
          />
        )}
      </>
      }
    </div>}
    textHeader={t('Preview')}
    textClose={t('Close')}
    type={'preview'}
    isLoading={isBusy}
  />
}
export default PreviewFileModal